import React from "react";
import { Mail, Phone, Clock, ArrowRight, Sparkles } from "lucide-react";

const Contact = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36 bg-slate-50 text-emerald-800">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-6 text-emerald-900">Let's Connect</h1>
          <p className="text-lg text-emerald-700 max-w-2xl mx-auto">
            Have questions about transforming your fitness, wellness, or recreation business? We’d love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Card */}
      <section className="pb-16 md:pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-gradient-to-br from-emerald-900 via-emerald-700 to-emerald-900 text-white rounded-3xl p-8 md:p-12 shadow-lg relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-lime-200 opacity-10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-sky-300 opacity-10 rounded-full blur-3xl"></div>

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="bg-lime-200 p-3 rounded-2xl">
                  <Sparkles size={28} className="text-emerald-900" />
                </div>
                <h2 className="text-2xl font-bold text-white">Ready to Get Started?</h2>
              </div>

              <p className="mb-8 text-white/90 leading-relaxed">
                Drop us an email and let's discuss how we can help transform your business with cutting-edge technology solutions. Whether you're looking for consulting, training, or innovative products, we're here to help you succeed.
              </p>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8 border border-white/20">
                <div className="flex items-center gap-4">
                  <div className="bg-lime-200 p-3 rounded-xl">
                    <Mail size={24} className="text-emerald-900" />
                  </div>
                  <div>
                    <p className="text-sm text-white/70 mb-1">Email us at</p>
                    <a
                      href="mailto:info@fitnovexa.com"
                      className="text-2xl font-bold text-lime-200 hover:opacity-80 transition-opacity"
                    >
                      info@fitnovexa.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/20">
                <a
                  href="mailto:info@fitnovexa.com"
                  className="inline-flex items-center gap-3 bg-lime-200 text-emerald-900 px-8 py-4 rounded-full font-bold text-lg hover:opacity-90 transition-all group"
                >
                  Send us an email
                  <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            </div>
          </div>

          {/* Secondary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <div className="bg-white rounded-2xl shadow-md p-6">
              <div className="flex items-start gap-4">
                <div className="bg-sky-200 p-4 rounded-2xl">
                  <Phone size={28} className="text-sky-700" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-emerald-900 mb-1">Call Us</h3>
                  <a
                    href="tel:+12025054544"
                    className="text-lg font-semibold text-emerald-700 hover:text-sky-700"
                  >
                    (202) 505-4544
                  </a>
                  <p className="text-sm text-gray-600 mt-2">Mon–Fri, 9am–6pm EST</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-md p-6">
              <div className="flex items-start gap-4">
                <div className="bg-lime-200 p-4 rounded-2xl">
                  <Clock size={28} className="text-emerald-900" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-emerald-900 mb-1">Response Time</h3>
                  <p className="text-lg font-semibold text-emerald-700">Within 48 Hours</p>
                  <p className="text-sm text-gray-600 mt-2">We value your time</p>
                </div>
              </div>
            </div>
          </div>

          {/* Location Info */}
          <div className="bg-white mt-8 p-6 rounded-2xl text-center shadow-md border border-gray-100">
            <p className="text-emerald-700 mb-2">
              <span className="font-semibold text-emerald-900">Based in Virginia</span> • Serving clients nationwide
            </p>
            <p className="text-sm text-gray-600">
              Led by Oz Altun, PhD with 20 years of innovation in fitness and recreation technology
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
